import apiUrl from '../../../utils/settings';

export const AddDistributorSellInvoiceUrl = () => {
  return apiUrl + '/user-invoices/sell-product';
};
export const GetCompanyWiseInventoryDataUrl = () => {
  return apiUrl + '/user-inventory/company-wise-inventory';
};
export const GetProductWiseinventoryDataUrl = () => {
  return apiUrl + '/user-inventory/paginated';
};
export const getUserInventoryTransactionsStpInfoUrl = () => {
  return (
    apiUrl +
    '/user-inventory-transactions/ship-to-party-info'
  );
};
export const SendOtpToGiftRecieverUrl = () => {
  return apiUrl + '/users-gifts/send-otp-to-gift-receiver';
};
export const VerifyOtpToGiftRecieverUrl = () => {
  return apiUrl + '/users-gifts/verify-otp-send-code-of-gift';
};
export const UploadGiftImageUrl = () => {
  return apiUrl + '/users-gifts/upload-gift-images';
};
export const SendOtpToMasonGiftRecieverUrl = () => {
  return apiUrl + '/users-gifts/send-otp-request-to-gift-receiver-mason';
};
export const UpdateGiftStatusUrl = () => {
  return apiUrl + '/users-gifts/update-gift-transaction-status';
};
export const registerNotificationTokenUrl = (token) => {
  return apiUrl + `/user-notifications/add-new-token?token_string=${token}`;
};
export const deleteNotificationTokenUrl = (token) => {
  return (
    apiUrl +
    `/user-notifications/delete-registration-token?token_string=${token}`
  );
};
export const GetNotificationPaginUrl = () => {
  return (
    apiUrl + '/user-notification-history/get-notification-history-paginated'
  );
};
